import { Helmet } from '@dr.pogodin/react-helmet';
import NoticeSiteHasBeenArchived from '../common/lib/NoticeSiteHasBeenArchived';
import PageNotFound from '../common/lib/PageNotFound';
import type { MultiLang } from '../config';
import Functions from '../functions';
import './assets/pubmedpdf.css';
import PubmedPdfBreadcrumbs from './lib/PubmedPdfBreadcrumbs';
import PubmedPdfListItemPaper from './lib/PubmedPdfPaper';
import PubmedPdfUtils, { type PubmedPdfBreadcrumbsData } from './lib/PubmedPdfUtils';

interface Props {
    lang: MultiLang;
    year: number;
    journalId: number;
}

const PubmedPdfPapersByYear = (props: Props) => {
    const { lang, year, journalId } = props;
    const name = PubmedPdfUtils.getName();
    const mtitle = Functions.mlang(name, lang);
    const journal = PubmedPdfUtils.getJournal(journalId);
    if (journal === null) {
        return <PageNotFound lang={lang} />;
    }
    const breadcrumbs: PubmedPdfBreadcrumbsData[] = [
        { id: `y.${year}`, name: `${year}`, link: PubmedPdfUtils.getYearUrl(year, 0) },
        {
            id: `j.${journal.id}`,
            name: Functions.mlang(journal.name, lang),
            link: PubmedPdfUtils.getYearUrl(year, journalId),
        },
    ];
    const papers = PubmedPdfUtils.getPapersByJournalId(journalId, year);
    return (
        <div className="pubmedpdf">
            <Helmet>
                <title>
                    {mtitle} - {Functions.siteTitle(lang)}
                </title>
            </Helmet>
            <h3>{mtitle}</h3>
            <NoticeSiteHasBeenArchived lang={lang} />
            <PubmedPdfBreadcrumbs lang={lang} breadcrumbs={breadcrumbs} />
            <hr />
            <div className="papers">
                {papers.map((paper) => {
                    return <PubmedPdfListItemPaper key={paper.id} lang={lang} paper={paper} />;
                })}
            </div>
        </div>
    );
};

export default PubmedPdfPapersByYear;
